import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  rootWithTitle: {
    borderBottom: `0.0625rem solid ${theme.palette.divider}`,
    boxSizing: 'border-box',
    paddingBottom: '0.5rem'
  },

  title: {
    fontSize: theme.size.base,
    color: '#7F8487'
  },

  views: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginRight: '4rem'
  },

  viewsWithTitle: {
    marginRight: '0'
  },

  view: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100rem',
    padding: '0.5rem',
    fontSize: theme.size.sm,
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.main,
    color: 'white'
  },

  delete: {
    marginLeft: '0.5rem'
  }
}))

export default useStyles
